<app-environment-banner />
<app-contextual-help-drawer>
  <router-outlet />
</app-contextual-help-drawer>
